"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useTableSelectionCell_unstable", {
    enumerable: true,
    get: ()=>useTableSelectionCell_unstable
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _reactUtilities = require("@fluentui/react-utilities");
const _reactCheckbox = require("@fluentui/react-checkbox");
const _reactRadio = require("@fluentui/react-radio");
const _useTableCell = require("../TableCell/useTableCell");
const _tableContext = require("../../contexts/tableContext");
const useTableSelectionCell_unstable = (props, ref)=>{
    const tableCellState = (0, _useTableCell.useTableCell_unstable)(props, ref);
    const { noNativeElements  } = (0, _tableContext.useTableContext)();
    const { type ='checkbox' , checked =false , subtle =false , hidden =false  } = props;
    return {
        ...tableCellState,
        components: {
            ...tableCellState.components,
            checkboxIndicator: _reactCheckbox.Checkbox,
            radioIndicator: _reactRadio.Radio
        },
        checkboxIndicator: (0, _reactUtilities.resolveShorthand)(props.checkboxIndicator, {
            required: type === 'checkbox',
            defaultProps: {
                checked: props.checked
            }
        }),
        radioIndicator: (0, _reactUtilities.resolveShorthand)(props.radioIndicator, {
            required: type === 'radio',
            defaultProps: {
                checked: !!checked,
                input: {
                    name: (0, _reactUtilities.useId)('table-selection-radio')
                }
            }
        }),
        type,
        checked,
        noNativeElements,
        subtle,
        hidden
    };
}; //# sourceMappingURL=useTableSelectionCell.js.map

//# sourceMappingURL=useTableSelectionCell.js.map